export enum SignOffStatus {
  Pending = 0,
  Approved = 1,
  Disapproved = 2,
  ApprovedWithCondition = 3,
  NotApplicable = 4,
  Incomplete = 5
}

export class WorkflowApplicationSignOff {
  id: string;
  workflowApplicationId: string;
  workflowApplicationActivityDataId?: string;
  assignedToUserId?: string;
  assignedOn?: Date;
  status: SignOffStatus;
  comments?: string;
  decisionDate?: Date;
  completedByUserId?: string;
  completedOn?: Date;
  createdBy: string;
  createdOn: Date;
  modifiedBy?: string;
  modifiedOn?: Date;
  deletedOn?: Date;
  deletedBy?: string;
  assignedToUserName?: string;
  completedByUserName?: string;

  constructor(data?: Partial<WorkflowApplicationSignOff>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  statusDisplay(): string {
    switch (this.status) {
      case SignOffStatus.Pending:
        return 'Pending';
      case SignOffStatus.Approved:
        return 'Approved';
      case SignOffStatus.Disapproved:
        return 'Disapproved';
      case SignOffStatus.ApprovedWithCondition:
        return 'Approved with Condition';
      case SignOffStatus.NotApplicable:
        return 'Not Applicable';
      case SignOffStatus.Incomplete:
        return 'Incomplete';
      default:
        return 'Unknown';
    }
  }
}
